export const CONSIGNOR_PARTS_SEPARATOR = ' '
